import React from 'react';
import { useEasybase } from 'easybase-react';
import { AppBar, Tabs, Tab, Box } from '@material-ui/core';
import Schablonen from './Schablonen';
import AktuelleBuchungen from './AktuelleBuchungen';
import Kursuebersicht from './Kursuebersicht';

export const FunktionsTabs = (props) => {
    const { userID } = useEasybase();
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        if (event === null) return;
        setValue(newValue);
    };
    const [rehaAdmin] = React.useState(props.rehasportName === userID());
    const [arenaAdmin] = React.useState(props.sportarenaName === userID());

    return (
        <div>
            <AppBar position="static">
                <Tabs value={value} onChange={handleChange} aria-label="my tabs">
                    <Tab label="aktuelle Buchungen" index={0} aria-controls="tabpanel-0" />
                    <Tab label="Kurs&uuml;bersicht" index={1} aria-controls="tabpanel-1" />
                    {(rehaAdmin||arenaAdmin) && (<Tab label="Schablonen" index={2} disabled={!arenaAdmin} aria-controls="tabpanel-2" />)}
                </Tabs>
            </AppBar>
            {value === 0 && (
                <div role="tabpanel" hidden={value !== 0} id="simple-tabpanel-0" aria-labelledby="tabpanel-0">
                    <Box p={3}><AktuelleBuchungen sr={props.sr} wer={userID()} /></Box>
                </div>
            )}
            {value === 1 && (
                <div role="tabpanel" hidden={value !== 1} id="simple-tabpanel-1" aria-labelledby="tabpanel-1">
                    <Box p={3}><Kursuebersicht sr={props.sr} wer={userID()} adminRechte={rehaAdmin||arenaAdmin} /></Box>
                </div>
            )}
            {value === 2 && (arenaAdmin||rehaAdmin) && (
                <div role="tabpanel" hidden={value !== 2} id="simple-tabpanel-2" aria-labelledby="tabpanel-2">
                    <Box p={3}><Schablonen sr={props.sr} /></Box>
                </div>
            )}
        </div>
    );
}
export default FunktionsTabs;